import { DetailTable, DetailTableRow } from "../components/DetailTable";
import { COMING_SOON } from "@/entities/CreditBox/CreditBox.types";
import { useFlags } from "@/utils/flagsmith/useFlags";

export function FundingAndValuation() {
    const flags = useFlags();
    const showComingSoon = flags.enabled("show-coming-soon-placeholders");

    const valuationData: DetailTableRow[] = [
        ...(showComingSoon
            ? [
                  {
                      label: "Total Value",
                      value: COMING_SOON,
                  },
                  { label: "Methodology", value: COMING_SOON },
                  { label: "Loan to Value", value: COMING_SOON },
              ]
            : []),
    ];

    if (!showComingSoon) {
        return null;
    }

    return (
        <div className="space-y-12">
            <DetailTable title="Valuation" data={valuationData} />
        </div>
    );
}
